var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AhaaGoodsCard } from './components/ahaa-goods-card';
import { FoodGoodsCard } from './components/food-goods-card';
import { WithImage } from './components/with-image';
import { WithTitle1 } from './components/with-title-1';
import { WithTitle2 } from './components/with-title-2';
import { CustomGoodsCard } from './components/goods-card-custom';
export var Goods = function Goods(props) {
  var mode = props.mode,
    restProps = __rest(props, ["mode"]);
  // function link(goods: any) {
  //     props.triggerEvent('onLink', {
  //         linkType: 'product',
  //         linkParams: {
  //             name: goods.cskuName,
  //             id: goods.csku,
  //             csku: goods.csku,
  //         },
  //     });
  // }
  function addCart(goods, count) {
    props.triggerRequest('addCart', {
      requestData: {
        csku: goods.csku,
        rsku: goods.rsku,
        count: count,
        goodsSpec: goods.goodsSpec,
        promotionId: goods.promotionId
      }
    });
  }
  function collect(goods, isFavorite) {
    return props.triggerRequest('collect', {
      requestData: {
        csku: goods.csku,
        isFavorite: isFavorite
      }
    });
  }
  switch (mode) {
    case 'goodsCard':
      switch (props.goodsCardStyle) {
        case 1:
          return _jsx(AhaaGoodsCard, Object.assign({}, restProps, {
            onAddCart: addCart,
            onCollect: collect
          }));
        case 2:
          return _jsx(FoodGoodsCard, Object.assign({}, restProps, {
            onAddCart: addCart,
            onCollect: collect
          }));
        default:
          return _jsx(AhaaGoodsCard, Object.assign({}, restProps, {
            onAddCart: addCart,
            onCollect: collect
          }));
      }
    case 'ahaaGoodsCard':
      return _jsx(AhaaGoodsCard, Object.assign({}, restProps, {
        onAddCart: addCart,
        onCollect: collect
      }));
    case 'foodGoodsCard':
      return _jsx(FoodGoodsCard, Object.assign({}, restProps, {
        onAddCart: addCart,
        onCollect: collect
      }));
    case 'withImage':
      return _jsx(WithImage, Object.assign({}, restProps));
    case 'withTitle1':
      return _jsx(WithTitle1, Object.assign({}, restProps, {
        onAddCart: addCart,
        onCollect: collect
      }));
    case 'withTitle2':
      return _jsx(WithTitle2, Object.assign({}, restProps, {
        onAddCart: addCart,
        onCollect: collect
      }));
    case 'goodsCardCustom':
      return _jsx(CustomGoodsCard, Object.assign({}, restProps));
    default:
      return null;
  }
};
export default Goods;